<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div v-if="!loading">
            <div class="row">
                <div class="col-md-12">
                    <b-alert :show="data.status == 0" variant="warning">
                        <i class="fa fa-sync-alt mr-2"></i> Podanie oczekuje na rozpatrzenie!
                    </b-alert>
                    <b-alert :show="data.status == 1" variant="success">
                        <i class="fa fa-check mr-2"></i> Podanie zostało zaakceptowane!
                    </b-alert>
                    <b-alert :show="data.status == 2" variant="danger">
                        <i class="fa fa-times mr-2"></i> Podanie zostało odrzucone!
                    </b-alert>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            Podanie użytkownika: {{ data.user.clientNick }}
                        </div>
                        <div class="card-body">
                            <form class="needs-validation" @submit.prevent="handleSave">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input
                                                id="email"
                                                v-model="data.content.email"
                                                class="form-control"
                                                placeholder="cebula@gmail.com"
                                                type="text"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="ts_knowledge">Znajomość aplikacji TS3</label>
                                            <select
                                                id="ts_knowledge"
                                                v-model="data.content.ts_knowledge"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="null" selected disabled>Wybierz opcję</option>
                                                <option v-for="num in 10" :key="num" :value="num">{{ num }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="when_presence">W jakich porach dnia przebywasz u nas
                                                najczęściej</label>
                                            <select
                                                id="when_presence"
                                                v-model="data.content.when_presence"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="null" selected disabled>Wybierz opcję</option>
                                                <option value="0">Porannych</option>
                                                <option value="1">Południowych</option>
                                                <option value="2">Wieczornych</option>
                                                <option value="3">Nocnych</option>
                                                <option value="4">W każdej</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="admin_elsewhere">Czy jesteś gdzieś obecnie adminem</label>
                                            <select
                                                id="admin_elsewhere"
                                                v-model="data.content.admin_elsewhere"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="null" selected disabled>Wybierz opcję</option>
                                                <option value="0">Nie</option>
                                                <option value="1">Tak</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="was_admin">Czy byłeś już gdzieś adminem</label>
                                            <select
                                                id="was_admin"
                                                v-model="data.content.was_admin"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="null" selected disabled>Wybierz opcję</option>
                                                <option value="0">Nie</option>
                                                <option value="1">Tak</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="age">Ile masz lat</label>
                                            <input
                                                id="age"
                                                v-model="data.content.age"
                                                class="form-control"
                                                type="number"
                                                placeholder="18"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="possible_time_spent">Ile czasu możesz poświęcić dziennie na
                                                pracę administratora</label>
                                            <select
                                                id="possible_time_spent"
                                                v-model="data.content.possible_time_spent"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="null" selected disabled>Wybierz opcję</option>
                                                <option value="0">0 - 2h</option>
                                                <option value="1">2 - 4h</option>
                                                <option value="2">4 - 6h</option>
                                                <option value="3">6 - 10h</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="about_me">Co możesz powiedzieć o sobie</label>
                                            <textarea
                                                id="about_me"
                                                v-model="data.content.about_me"
                                                class="form-control"
                                                disabled
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="additional_info">Dodatkowe informacje</label>
                                            <textarea
                                                id="additional_info"
                                                v-model="data.content.additional_info"
                                                class="form-control"
                                                disabled
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            Odpowiedz na to podanie
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="response">
                                            Wiadomość zwrotna
                                            <i class="fa fa-question-circle" id="msg-info"></i>
                                            <b-tooltip target="msg-info" placement="bottom" noninteractive>
                                                Nie musisz uzupełniać tego pola. Wiadomość zwrotna, jeśli ją podasz, pokaże się użytkownikowi, który złożył podanie.
                                                Możesz tutaj napisać np. że drugi etap rekrutacji jest w sobotę lub, że podanie nie zostało zaakceptowane bo użytkownik jest za młody.
                                            </b-tooltip>
                                        </label>
                                        <textarea
                                            id="response"
                                            v-model="response"
                                            class="form-control"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around">
                                <button class="btn btn-success" @click="saveResponse(true)">
                                    <i class="fa fa-check"></i> Zaackeptuj
                                </button>
                                <button class="btn btn-danger" @click="saveResponse(false)">
                                    <i class="fa fa-times"></i> Odrzuć
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-md-12">
                    <button class="btn btn-danger" @click="() => $router.push({name: 'admin.recruitment'})">
                        <i class="fa fa-arrow-left"></i> Powrót
                    </button>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import RecruitmentService from "@/services/recruitment.service";
import {
    notificationMethods
} from "@/state/helpers";
import Vue from 'vue';

/**
 * Starter component
 */
export default {
    name: "RecruitmentSingle",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Podgląd podania",
            items: [
                {
                    text: "Admin",
                    href: "/"
                },
                {
                    text: "Podgląd podania",
                    active: true
                }
            ],
            loading: true,
            response: "",
            data: {}
        };
    },
    computed: {
        applicationId() {
            return this.$route.params.id;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        loadData() {
            this.loading = true;

            RecruitmentService.getAdminSingle(this.applicationId).then(
                response => {
                    this.data = response.data
                    this.response = this.data.response;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        async saveResponse(type) {
            if (this.data.status != 0) {
                let result = await Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "To podanie ma już przypisany status!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Anuluj'
                });

                if (!result || !result.value)
                    return;
            }

            this.loading = true;

            RecruitmentService.saveAdmin({type: type, id: this.applicationId, response: this.response}).then(
                () => {
                    if (type)
                        this.success("Podanie zostało zaakceptowane");
                    else
                        this.success("Podanie zostało odrzucone");

                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        }
    }
};
</script>